import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert
} from '@mui/material';
import { useOrganization } from '../../../contexts/OrganizationContext';

const CreateOrganizationDialog = ({ open, onClose }) => {
  const { createOrganization, loading } = useOrganization();

  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState('');

  const handleClose = () => {
    setName('');
    setError(null);
    setValidationError('');
    onClose();
  };

  const validateName = (value) => {
    if (!value.trim()) {
      setValidationError('Organization name is required');
      return false;
    }
    if (value.trim().length < 2) {
      setValidationError('Organization name must be at least 2 characters');
      return false;
    }
    if (value.trim().length > 100) {
      setValidationError('Organization name must be less than 100 characters');
      return false;
    }
    setValidationError('');
    return true;
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    validateName(value);
  };

  const handleSubmit = async () => {
    if (!validateName(name)) {
      return;
    }

    setError(null);

    try {
      await createOrganization(name.trim());
      handleClose();
    } catch (err) {
      setError(err.message || 'Failed to create organization');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !validationError && name.trim()) {
      handleSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Organization</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          autoFocus
          margin="dense"
          label="Organization Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={handleNameChange}
          onKeyPress={handleKeyPress}
          error={!!validationError}
          helperText={validationError || 'e.g., Acme Corporation, Marketing Team'}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !!validationError || !name.trim()}
        >
          {loading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateOrganizationDialog;
